import type { RouterRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'router'
const routerSiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const routerRefs: RouterRefs = {
	currentUrl: () => routerSiteRefProvider(['currentUrl']),
	currentUrlWithQueryParams: () => routerSiteRefProvider(['currentUrlWithQueryParams']),
	relativeUrl: () => routerSiteRefProvider(['relativeUrl']),
	addOnUrlChangeListener: () => routerSiteRefProvider(['addOnUrlChangeListener']),
	removeOnUrlChangeListener: () => routerSiteRefProvider(['removeOnUrlChangeListener']),
	pageId: () => routerSiteRefProvider(['pageId']),
}
export { routerRefs }
